import store from '@/stores/store'
import { getAppDisplayName } from '@/appDisplayNames'

const CmCrono = () => import(/* webpackChunkName: "cm-crono" */ '@/components/cm-crono.vue')
const Index = () => import(/* webpackChunkName: "cm-crono" */ '@/components/cm-crono/Index')
const Consult = () => import(/* webpackChunkName: "cm-crono" */ '@/components/cm-crono/Consult')
const Show = () => import(/* webpackChunkName: "cm-crono" */ '@/components/cm-crono/Show')
const Setting = () => import(/* webpackChunkName: "cm-crono" */ '@/components/cm-crono/Setting')

const getAppName = () => getAppDisplayName('cm-crono', store.getters.getPartner)

export default {
  children: [
    {
      component: Index,
      meta: {
        breadcrumbs: [{ dynamicName: getAppName }]
      },
      path: '/'
    },
    {
      component: Consult,
      meta: {
        breadcrumbs: [
          { link: '/cm-crono', dynamicName: getAppName },
          { name: 'Históricos de Consultas' },
        ]
      },
      path: 'consultas'
    },
    {
      component: Setting,
      meta: {
        breadcrumbs: [
          { link: '/cm-crono', dynamicName: getAppName },
          { name: 'Configurações' },
        ]
      },
      path: 'configuracoes'
    },
    {
      component: Show,
      meta: {
        breadcrumbs: [
          { link: '/cm-crono', dynamicName: getAppName },
          { dynamicName: () => store.getters.getNameBreadcrumb, name: 'Show' },
        ]
      },
      path: 'cronotacografo/:id',
      props: true
    }
  ],
  component: CmCrono,
  path: 'cm-crono'
}
